function createMissingObjectUi(data, objectType, layerName, layerSubtype, obj2dType, objIdProperty) {
    for (let slideData of data.slides) {
        let missingUuids = {};

        for (let objectUuid in slideData.animation) {
            let objectData = data.assets.objects[objectUuid];
            if (objectData && objectData.type === objectType) {
                missingUuids[objectUuid] = true;
            }
        }

        for (let layerUuid in slideData.layers) {
            let layerData = data.layers.layers2D[layerUuid];
            if (layerData && layerData.type === '2D' && layerData.subtype === layerSubtype) {
                for (let obj2dUuid in layerData.objects) {
                    let obj2dData = layerData.objects[obj2dUuid];
                    if (obj2dData.type === obj2dType) {
                        delete missingUuids[obj2dData[objIdProperty]];
                    }
                }
            }
        }

        for (let objectUuid in missingUuids) {
            let layerData = {
                name: layerName,
                objects: {},
                type: '2D',
                subtype: layerSubtype,
                visible: true,
            };

            let obj2dData = { type: obj2dType };
            obj2dData[objIdProperty] = objectUuid;

            let layerUuid = THREE.Math.generateUUID();
            layerData.objects[THREE.Math.generateUUID()] = obj2dData;
            data.layers.layers2D[layerUuid] = layerData;
            slideData.layers[layerUuid] = true;
            slideData.layers2D[layerUuid] = 1;
        }
    }
}

function assignMissingLayerIndices(data) {
    let layerTypeChildren = {};
    let layerTypes = {};

    for (let uuid in data) {
        let layerData = data[uuid];
        let objUuid = Object.keys(layerData.objects)[0];
        let objectData = layerData.objects[objUuid];

        if (objectData && objectData.type) {
            let layerType = objectData.type;
            layerTypes[uuid] = layerType;

            let siblings = layerTypeChildren[layerType];
            if (!siblings) {
                siblings = [];
                layerTypeChildren[layerType] = siblings;
            }

            if ('index' in layerData) {
                siblings[layerData.index] = uuid;
            }
        }
    }

    for (let uuid in layerTypes) {
        let layerData = data[uuid];

        if (!('index' in layerData)) {
            let layerType = layerTypes[uuid];
            let siblings = layerTypeChildren[layerType];

            layerData.index = 0;
            while (siblings[layerData.index]) layerData.index++;
            siblings[layerData.index] = uuid;
        }
    }
}

function initLayers(data) {
    assignMissingLayerIndices(data.layers.layers2D);
}

export default initLayers;
